import { _ as __assign } from '../../chunks/bundle-C7jYHvwG.js';
import React__default from 'react';
import { M as MessageInputWrapperView } from '../../chunks/bundle-DRyEkedz.js';
export { V as VoiceMessageInputWrapper } from '../../chunks/bundle-DRyEkedz.js';
import { useGroupChannelContext } from '../context.js';
import '../../chunks/bundle-C1U8wE49.js';
import '../../chunks/bundle-Dpdq7qeD.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-CIN9yQRB.js';
import '../../chunks/bundle-pOZPN8hk.js';
import './SuggestedMentionList.js';
import '../../chunks/bundle-BL_0pgq0.js';
import '../../chunks/bundle-DImSV9VW.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-DUTyBaXr.js';
import '../../chunks/bundle-CbEyAimK.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-BR3O1lZq.js';
import '../../chunks/bundle-4W3uBGU3.js';
import '../../chunks/bundle-C9dF4QVS.js';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/QuoteMessageInput.js';
import '../../chunks/bundle-DYeeW5nS.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-CDjVXDOc.js';
import '../../chunks/bundle-Dl9NVsui.js';
import '../../chunks/bundle-DkviGBGz.js';
import '../../chunks/bundle-jw_xHmHg.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-CLonR-iH.js';
import '../../chunks/bundle-MyLy9AIu.js';
import 'react-dom';
import '../../chunks/bundle-DfDrbjM5.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '@sendbird/uikit-tools';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-C6-Ix-Lk.js';
import '../../ui/SortByRow.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../chunks/bundle-CTE4m7bC.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ProgressBar.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-Ci2fMtNJ.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-DCX2mqfp.js';
import 'dompurify';
import '../../chunks/bundle-BMygDCXK.js';
import '../../chunks/bundle-P-vXuw8U.js';
import '../../chunks/bundle-BBowfNDO.js';
import '../../chunks/bundle-_-FiwcfQ.js';
import '../../chunks/bundle-2kzSicIw.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-gQ2a8Eki.js';
import '../../chunks/bundle-MrMJJXf2.js';
import '../../chunks/bundle-ryUmMhVP.js';
import '../../chunks/bundle-90vsNbxW.js';
import '../../chunks/bundle-MkyS3j4-.js';
import '../../chunks/bundle-LPNnEgGp.js';

var MessageInputWrapper = function (props) {
    var context = useGroupChannelContext();
    return React__default.createElement(MessageInputWrapperView, __assign({}, props, context));
};

export { MessageInputWrapper, MessageInputWrapper as default };
//# sourceMappingURL=MessageInputWrapper.js.map
